export const exportFields = {
  "First Name": "name.first",
  "Last Name": "name.last",
  Email: "authentication.email",
  "Phone Number": "authentication.phone",
  Area: "address.street2",
  City: "address.city",
  Country: "address.country",
  Zip: "address.zip",
  Category: "category",
  customerNo: "customerNo",
  "Created At": "createdAt"
};
